

import {Component, Vue, Prop } from "vue-property-decorator"
import moment from 'moment-timezone';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component
export default class PageBase extends Vue {
       
    @Prop({required: false, default:false})
    hideNavButtons!: boolean;
    
    @Prop({required: false})
    disableNext!: boolean;

    @Prop({required: false})
    disableNextText!: String;
    
    error: ""
 
    public onPrev() {     
        if (this.$listeners && this.$listeners.onPrev) {
            this.$emit('onPrev');
        } else {
            Vue.prototype.$UpdateGotoPrevStepPage()
        }
    }

    public onNext() {
        if (!this.isDisableNext()) {
            if (this.$listeners && this.$listeners.onNext) {  
                this.$emit('onNext');
            } else {
                Vue.prototype.$UpdateGotoNextStepPage()
            }
        }
    }


    public hasPrevStepPage() {
        return this.$store.getters["Application/getPrevStepPage"] != null;
    }

    public hasNextStepPage() {        
        return this.$store.getters["Application/getNextStepPage"] != null;
       
    }

    public canComplete() {
        return this.$store.getters["Application/getNextStepPage"] == null;
    }

    public isDisableNext() {
        return this.disableNext;
    }
  
};
